module.exports = __webpack_public_path__ + "media/img/pages/companies/aldi-b487a6118ea7452c3fb1c62db97451f7.png";